import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CycleDetails from "./routes/CycleDetails";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "snp",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "snp" */ "./components"),
        import(/* webpackChunkName: "snp" */ "SnP/modules/SnPModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "snpV2",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CycleDetails(store)],
});
